import { useQuery } from '@tanstack/react-query';
import { apiService } from '@/lib/api';

// 24 hours stale time for catalog data
const CATALOG_STALE_TIME = 1000 * 60 * 60 * 24;

export interface BloodPressurePosition {
  id: number;
  name: string;
  display_name: string;
}

export interface BloodPressureLocation {
  id: number;
  name: string;
  location: string;
}

export const useBloodPressurePositions = () => {
  const { 
    data: positions = [], 
    isLoading: loading, 
    error: queryError,
    refetch 
  } = useQuery({
    queryKey: ['bloodPressurePositions'],
    queryFn: async () => {
      const response = await apiService.getBloodPressurePositions();
      return response.data;
    },
    staleTime: CATALOG_STALE_TIME,
    gcTime: CATALOG_STALE_TIME,
  });

  const error = queryError ? (queryError as Error).message || 'Failed to fetch blood pressure positions' : null;

  return {
    positions,
    loading,
    error,
    refetch
  };
};

export const useBloodPressureLocations = () => {
  const { 
    data: locations = [], 
    isLoading: loading, 
    error: queryError,
    refetch 
  } = useQuery({
    queryKey: ['bloodPressureLocations'],
    queryFn: async () => {
      const response = await apiService.getBloodPressureLocations();
      return response.data;
    },
    staleTime: CATALOG_STALE_TIME,
    gcTime: CATALOG_STALE_TIME,
  });

  const error = queryError ? (queryError as Error).message || 'Failed to fetch blood pressure locations' : null;

  return {
    locations,
    loading,
    error,
    refetch
  };
};
